module.exports = __webpack_public_path__ + "static/media/3.e0056866.png";